<template>
  <div class="nav-sticky-top">
    <nav class="navbar nav-header">
      <b-navbar-toggle
        target="nav-text-collapse"
        class="toggle-icon shadow-none d-sm-none d-block d-md-block d-lg-none"
      >
        <i class="bi bi-list"></i>
      </b-navbar-toggle>
      <a class="navbar-brand m-auto" href="#">
        <img src="@/assets/ResearchLogo.svg" class="research-logo" />
      </a>
    </nav>
    <b-navbar
      toggleable="lg"
      class="navbar navbar-expand-lg navbar-light nav-shadow nav-white hide-p-mobile"
    >
      <b-collapse id="nav-text-collapse" is-nav>
        <b-navbar-nav>
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link
                to="/"
                class="nav-link"
                :class="currentRoute.name == 'Home' ? 'active' : ''"
              >
                Home
              </router-link>
            </li>
            <li class="nav-item" v-b-toggle.collapse-1>
              <a
                class="nav-link"
                :class="currentRoute.path.includes('Reports') ? 'active' : ''"
                >Reports<i class="bi bi-chevron-down"></i
              ></a>
            </li>
            <li class="nav-item">
              <router-link
                :to="'/Learn?keyword=' + featuredVideo.videoTitle"
                class="nav-link"
                :class="currentRoute.name == 'learn' ? 'active' : ''"
              >
                Learn
              </router-link>
            </li>

            <li class="nav-item">
              <!-- <router-link
                to="/TsupitHeroCorner"
                class="nav-link"
                :class="currentRoute.path.includes('TsupitHeroCorner') ? 'active' : ''"
              >
                TsupitHero's Corner
              </router-link> -->
              <a class="nav-link" v-b-modal.coming> TsupitHero's Corner</a>
            </li>
            <li class="nav-item">
              <!-- <router-link
                to="/KapitmansCorner"
                class="nav-link"
                :class="currentRoute.path.includes('KapitmansCorner') ? 'active' : ''"
              >
                KapitMan's Corner
              </router-link> -->

              <a class="nav-link" v-b-modal.kapitman> KapitMan's Corner</a>
            </li>
            <li class="search-input-list d-none">
              <div class="d-flex align-items-center">
                <input
                  type="text"
                  class="form-control shadow-none search-input"
                  placeholder="Search symbol or company name"
                />
                <button class="glob-btn btn search-icon">
                  <i class="bi bi-search"></i>
                </button>
              </div>
              <b-list-group class="search-suggestion">
                <b-list-group-item class="suggest-list">
                  <label>2GO (2Go Group, Inc.)</label>
                  <p class="mb-0">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod
                  </p>
                </b-list-group-item>
                <b-list-group-item class="suggest-list">
                  <label>2GO (2Go Group, Inc.)</label>
                  <p class="mb-0">tempor incididunt ut labore et</p>
                </b-list-group-item>
                <b-list-group-item class="suggest-list">
                  <label>2GO (2Go Group, Inc.)</label>
                  <p class="mb-0">dolore magna aliqua. Ut enim ad minim veniam</p>
                </b-list-group-item>
                <b-list-group-item class="suggest-list">
                  <label>2GO (2Go Group, Inc.)</label>
                  <p class="mb-0">aliqua. Ut enim ad minim veniam</p>
                </b-list-group-item>
              </b-list-group>
            </li>
          </ul>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div>
      <b-collapse id="collapse-1" class="report-collapse mt-n-2">
        <b-card>
          <div class="row mobile-responsive">
            <label
              v-b-toggle.collapse-1
              class="mb-0 text-right d-lg-none d-lg-block"
              title="close"
            >
              <i class="bi bi-x" style="font-size: 2em; right: 1em"></i
            ></label>
            <div class="col">
              <div class="row">
                <div class="col-lg-2 col-md-12 col-12">
                  <div class="p-3">
                    <ul class="navigation-list">
                      <li class="navigation-list-header">General Market</li>
                      <li>
                        <div class="navigation-label">
                          <router-link
                            to="/Reports/Archive/DailyNotes"
                            :class="
                              currentRoute.name == 'DailyNotesArchive' ? 'active' : ''
                            "
                          >
                            Daily Notes
                          </router-link>
                          <!-- Daily Notes -->
                        </div>
                      </li>

                      <li>
                        <div class="group-label">
                          <router-link
                            :to="'/Reports/WeeklyNotes/Archive'"
                            :class="
                              currentRoute.name == 'WeeklyNotesArchive' ? 'active' : ''
                            "
                          >
                            Weekly Notes
                          </router-link>
                        </div>
                      </li>
                      <li v-b-toggle.market-updates>
                        <div
                          class="group-label"
                          :class="
                            currentRoute.name == 'MorningPrimerArchive' ||
                            currentRoute.name == 'MarketRecapArchive'
                              ? 'active'
                              : ''
                          "
                        >
                          Market Updates <i class="bi bi-chevron-down"></i>
                        </div>
                        <b-collapse
                          id="market-updates"
                          :class="
                            (currentRoute.name == 'MorningPrimerArchive' ||
                              currentRoute.name == 'MarketRecapArchive') &&
                            isActive
                              ? 'd-block'
                              : ''
                          "
                          :visible="
                            (currentRoute.name == 'MorningPrimerArchive' ||
                              currentRoute.name == 'MarketRecapArchive') &&
                            isActive
                          "
                          @hide="isActive = false"
                          @show="isActive = true"
                        >
                          <ul>
                            <li>
                              <router-link
                                to="/Reports/Archive/MorningPrimer"
                                :class="
                                  currentRoute.name == 'MorningPrimerArchive'
                                    ? 'active'
                                    : ''
                                "
                              >
                                Morning Primer
                              </router-link>
                            </li>
                            <li>
                              <router-link
                                to="/Reports/Archive/MarketRecap"
                                :class="
                                  currentRoute.name == 'MarketRecapArchive'
                                    ? 'active'
                                    : ''
                                "
                              >
                                Market Recap
                              </router-link>
                            </li>
                          </ul>
                        </b-collapse>
                      </li>
                      <li v-b-toggle.dividends>
                        <div
                          class="group-label"
                          :class="
                            currentRoute.name == 'UpcomingDividends' ||
                            currentRoute.name == 'PreferredSharesArchive' ||
                            currentRoute.name == 'ReitsArchive' || 
                            currentRoute.name == 'DividendYieldsArchive'
                              ? 'active'
                              : ''
                          "
                        >
                          Dividends <i class="bi bi-chevron-down"></i>
                        </div>
                        <b-collapse
                          id="dividends"
                          :class="
                            (currentRoute.name == 'UpcomingDividends' ||
                              currentRoute.name == 'PreferredSharesArchive' ||
                              currentRoute.name == 'ReitsArchive' || currentRoute.name == 'PSEiDividendArchive') &&
                            isActive
                              ? 'd-block'
                              : ''
                          "
                          :visible="
                            (currentRoute.name == 'UpcomingDividends' ||
                              currentRoute.name == 'PreferredSharesArchive' ||
                              currentRoute.name == 'ReitsArchive') &&
                            isActive
                          "
                          @hide="isActive = false"
                          @show="isActive = true"
                        >
                          <ul>
                            <li>
                              <router-link
                                to="/Reports/UpcomingDividends"
                                :class="
                                  currentRoute.name == 'UpcomingDividends' ? 'active' : ''
                                "
                              >
                                Dividend Updates
                              </router-link>
                            </li>
                            <li>
                              <router-link
                                :to="'/Reports/PreferredShares/Archive'"
                                :class="
                                  currentRoute.name == 'PreferredSharesArchive'
                                    ? 'active'
                                    : ''
                                "
                              >
                                Preferred Shares
                              </router-link>
                            </li>
                            <li>
                              <router-link
                                :to="'/Reports/REITs/Archive'"
                                :class="
                                  currentRoute.name == 'ReitsArchive' ? 'active' : ''
                                "
                              >
                                REITs
                              </router-link>
                            </li>
                            <li>
                              <router-link
                                :to="'/Reports/Archive/DividendYields'"
                                :class="
                                  currentRoute.name == 'DividendYieldsArchive' ? 'active' : ''
                                "
                              >
                               Dividend Yields
                              </router-link>
                            </li>
                          </ul>
                        </b-collapse>
                      </li>

                      <li>
                        <div class="group-label">
                          <router-link
                            :to="'/Reports/Archive/EarningScoreCard'"
                            :class="
                              currentRoute.name == 'EarningScorecardArchive'
                                ? 'active'
                                : ''
                            "
                          >
                            Earnings Scorecard
                          </router-link>
                        </div>
                      </li>
                      <li v-b-toggle.others>
                        <div
                          class="group-label"
                          :class="
                            currentRoute.name == 'MarketCalendar' ||
                            currentRoute.name == 'SharesBuyback'
                              ? 'active'
                              : ''
                          "
                        >
                          Others <i class="bi bi-chevron-down"></i>
                        </div>
                        <b-collapse
                          id="others"
                          :class="
                            (currentRoute.name == 'MarketCalendar' ||
                              currentRoute.name == 'SharesBuyback') &&
                            isActive
                              ? 'd-block'
                              : ''
                          "
                          :visible="
                            (currentRoute.name == 'MarketCalendar' ||
                              currentRoute.name == 'SharesBuybackArchive') &&
                            isActive
                          "
                          @hide="isActive = false"
                          @show="isActive = true"
                        >
                          <ul>
                            <li>
                              <router-link
                                to="/MarketCalendar"
                                :class="
                                  currentRoute.name == 'MarketCalendar' ? 'active' : ''
                                "
                              >
                                Market Calendar
                              </router-link>
                            </li>
                            <li>
                              <router-link
                                to="/Reports/Archive/SharesBuyback"
                                :class="
                                  currentRoute.name == 'SharesBuybackArchive'
                                    ? 'active'
                                    : ''
                                "
                              >
                                Share Buy-Back
                              </router-link>
                            </li>

                             <li>
                              <router-link
                                to="/Reports/Archive/OfferingsTable"
                                :class="
                                  currentRoute.name == 'OfferingsTableArchive'
                                    ? 'active'
                                    : ''
                                "
                              >
                                Offerings Table
                              </router-link>
                            </li>
                          </ul>
                        </b-collapse>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                  <div class="p-3">
                    <ul class="navigation-list">
                      <li class="navigation-list-header">Screened Stocks</li>
                      <li>
                        <div class="group-label">
                          <router-link
                            to="/Reports/Archive/MarketSnapshots"
                            :class="
                              currentRoute.name == 'MarketSnapshots' ? 'active' : ''
                            "
                          >
                            Market Snapshots
                          </router-link>
                        </div>
                      </li>

                      <li>
                        <div class="group-label">
                          <router-link
                            :to="'/Reports/Archive/StocksWithMomentum'"
                            :class="
                              currentRoute.name == 'StocksWithMomentumArchive'
                                ? 'active'
                                : ''
                            "
                          >
                            Stocks with Momentum
                          </router-link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-2 col-md-12 col-12">
                  <div class="p-3">
                    <ul class="navigation-list">
                      <li class="navigation-list-header">Investment Guidance</li>
                      <li>
                        <div class="group-label">
                          <router-link
                            :to="'/Reports/Archive/CompanyReport'"
                            :class="
                              currentRoute.name == 'CompanyReportsArchive' ? 'active' : ''
                            "
                          >
                            Company Report
                          </router-link>
                        </div>
                      </li>
                      <li v-b-toggle.capital-report>
                        <div
                          class="group-label"
                          :class="currentRoute.name == 'IPOReportArchive' || currentRoute.name == 'IPOPerformanceArchive' ? 'active' : ''"
                        >
                          Capital Raising Report
                          <i class="bi bi-chevron-down"></i>
                        </div>
                        <b-collapse
                          id="capital-report"
                          :class="
                            (currentRoute.name == 'IPOReportArchive' ||
                              currentRoute.name == 'IPOReport') &&
                            isActive
                              ? 'd-block'
                              : ''
                          "
                          :visible="
                            (currentRoute.name == 'IPOReportArchive' ||
                              currentRoute.name == 'IPOReport') &&
                            isActive
                          "
                          @hide="isActive = false"
                          @show="isActive = true"
                        >
                          <ul>
                            <li>
                              <router-link
                                :to="'/Reports/Archive/IPOReport'"
                                :class="
                                  currentRoute.name == 'IPOReportArchive' ? 'active' : ''
                                "
                              >
                                IPO Report
                              </router-link>
                            </li>
                            <li>
                              <router-link
                                :to="'/Reports/Archive/IPOPerformance'"
                                :class="
                                  currentRoute.name == 'IPOPerformanceArchive' ? 'active' : ''
                                "
                              >
                                IPO Performance
                              </router-link>
                            </li>
                            <!-- <li>SRO Report</li>
                            <li>FOO Report</li> -->
                          </ul>
                        </b-collapse>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-2 col-md-12 col-12">
                  <div class="p-3">
                    <ul class="navigation-list">
                      <li class="navigation-list-header">Trading Guidance</li>
                      <li>
                        <div class="group-label">
                          <router-link
                            :to="'/Reports/Archive/TradingPlanReport'"
                            :class="
                              currentRoute.name == 'TradingPlanReportArchive'
                                ? 'active'
                                : ''
                            "
                          >
                            Trading Plan Report
                          </router-link>
                        </div>
                      </li>
                      <li>
                        <div class="group-label">
                          <router-link
                            :to="'/Reports/Archive/TradersMenu'"
                            :class="
                              currentRoute.name == 'TradersMenuArchive'
                                ? 'active'
                                : ''
                            "
                          >
                            Trader's Menu
                          </router-link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- <------------------------>

                <div class="col-lg-2 col-md-12 col-12">
                  <div class="p-3">
                    <ul class="navigation-list">
                      <li class="navigation-list-header">Special Reports</li>
                      <li>
                        <div class="group-label">
                          <router-link
                            :to="'/Reports/Archive/PhilstocksForecast'"
                            :class="
                              currentRoute.name == 'PhilstocksForecastArchive'
                                ? 'active'
                                : ''
                            "
                          >
                            Philstocks Forecasts
                          </router-link>
                        </div>
                      </li>
                       <li>
                        <div class="group-label">
                          <router-link
                            :to="'/Reports/Archive/LearningGuide'"
                            :class="
                              currentRoute.name == 'LearningGuideArchive'
                                ? 'active'
                                : ''
                            "
                          >
                            Learning Guide
                          </router-link>
                        </div>
                      </li>
                         <li>
                              <router-link
                                :to="'/Reports/Archive/OtherSpecialReports'"
                                :class="
                                  currentRoute.name == 'OtherSpecialReportsArchive'
                                    ? 'active'
                                    : ''
                                "
                              >
                               Other Special Reports
                              </router-link>
                            </li>
                      <li v-b-toggle.strategies>
                        <div
                          class="group-label"
                          :class="
                            currentRoute.name == 'TradingStrategiesArchive' ||
                            currentRoute.name == 'InvestingStrategiesArchive' ||
                            currentRoute.name == 'InvestingStrategies'
                              ? 'active'
                              : ''
                          "
                        >
                          Strategies
                          <i class="bi bi-chevron-down"></i>
                        </div>
                        <b-collapse
                          id="strategies"
                          :class="
                            (currentRoute.name == 'TradingStrategiesArchive' ||
                              currentRoute.name == 'InvestingStrategies' ||
                              currentRoute.name == 'InvestingStrategiesArchive') &&
                            isActive
                              ? 'd-block'
                              : ''
                          "
                          :visible="
                            (currentRoute.name == 'TradingStrategiesArchive' ||
                              currentRoute.name == 'InvestingStrategiesArchive') &&
                            isActive
                          "
                          @hide="isActive = false"
                          @show="isActive = true"
                        >
                          <ul>
                            <li>
                              <router-link
                                :to="'/Reports/Archive/TradingStrategies'"
                                :class="
                                  currentRoute.name == 'TradingStrategiesArchive'
                                    ? 'active'
                                    : ''
                                "
                              >
                                Trading Strategies
                              </router-link>
                            </li>
                            <li>
                              <router-link
                                :to="'/Reports/Archive/InvestingStrategies'"
                                :class="
                                  currentRoute.name == 'InvestingStrategiesArchive'
                                    ? 'active'
                                    : ''
                                "
                              >
                                Investing Strategies
                              </router-link>
                            </li>

                             
                          </ul>
                        </b-collapse>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>

      <!-- Modal -->
      <!-- Modal -->

      <b-modal id="kapitman" title="BootstrapVue" v-model="isKapitman">
        <div style="position: absolute; right: 0">
          <i
            class="bi bi-x pointer m-4 text-right"
            style="font-size: 2em"
            @click="isKapitman = !isKapitman"
          ></i>
        </div>

        <div class="p-3">
          <h5 class="my-4 text-center mb-2">Hang in there mga Ka-Philstocks!</h5>

          <p class="text-center text-muted">
         Kapitman's Corner will serve as the base of our investors. Here you'll get to know what are the stocks we see as fundamentally strong and good for long term investing.
          </p>

          <!-- <div class="d-flex justify-content-center">

    <lottie-player src="https://assets3.lottiefiles.com/packages/lf20_zmrp62ng.json"  background="transparent"  speed="1"  style="width: 300px; height: 300px;"  loop  autoplay></lottie-player>

     </div> -->

          <p class="text-center text-muted mb-0">
            If you have any suggestions, shoot us an email at

            <a href="#link" class="text-center btn-link" role="button"
              >research@philstocks.ph</a
            >
          </p>
          <p class="text-center text-muted mb-0">
            <br/>
            All suggestions are highly appreciated.
          </p>
        </div>
      </b-modal>

        <b-modal id="coming" title="BootstrapVue" v-model="CommingSoon">
        <div style="position: absolute; right: 0">
          <i
            class="bi bi-x pointer m-4 text-right"
            style="font-size: 2em"
            @click="CommingSoon = !CommingSoon"
          ></i>
        </div>

        <div class="p-3">
          <h5 class="my-4 text-center mb-2">Hang in there mga Ka-Philstocks!</h5>

          <p class="text-center text-muted">
           Tsupithero's Corner will serve as the home of our traders. Here, you'll get to know what are the short term, tradable stocks that we are monitoring and recommending.
          </p>

          <!-- <div class="d-flex justify-content-center">

    <lottie-player src="https://assets3.lottiefiles.com/packages/lf20_zmrp62ng.json"  background="transparent"  speed="1"  style="width: 300px; height: 300px;"  loop  autoplay></lottie-player>

     </div> -->

          <p class="text-center text-muted mb-0">
            If you have any suggestions, shoot us an email at

            <a href="#link" class="text-center btn-link" role="button"
              >research@philstocks.ph</a
            >
          </p>
          <p class="text-center text-muted mb-0">
            <br/>
            All suggestions are highly appreciated.
          </p>
        </div>
      </b-modal>
    </div>
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isActive: true,
      CommingSoon: false,
      isKapitman:false,
      
    };
  },
  computed: {
    currentRoute() {
      return this.$route;
    },
    ...mapState({
      featuredVideo: (state) => state.philstocksResearch.LearnContent.featuredVideo,
    }),
  },
  methods: {
    UnderDevelopment() {
      alert("Coming Soon!");
    },
    closeModal() {
      this.$refs["comingl"].hide();
    },

    playVideos(data) {
      var payload = {
        videoArticle: data.videoArticle,
        videoSubtitle: data.videoSubtitle,
        videoTitle: data.videoTitle,
        videoUrl: data.videoUrl,
        isFromHomePage: false,
      };
      this.$router.push("/Learn");
      this.$store.dispatch("philstocksResearch/SET_IsSelectedVideo", payload);
    },
  },
  async mounted() {
    this.$store.dispatch("philstocksResearch/GetLearnContent");
  },
};
</script>
